import { Component, ElementRef, HostBinding, OnInit, ViewChild } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { Location } from '@angular/common';

import moment from 'moment';

import momentJalaali from 'moment-jalaali';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { pluck } from 'rxjs';

import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';

declare let $: any;

@Component({

  selector: 'Refule',

  templateUrl: './refuleComponent.html',

  styles: [`

    .modal label {
      background-color: white;
      position: relative;
      right: 8px;
      top: 18px;
      padding: 0 10px;
      font-size: 14px;
    }

    .form-control {
        padding-top: 10px;

    }

    .form-control:disabled,
    .form-control[readonly] {
        background-color: white !important;
        opacity: 1;
    }

    td, tr > th{
        vertical-align: middle;
    }

    .header-container{
        position: absolute;
        top: -30px;
        right: 13px;
        background: #fff;
        padding: 0 12px;
        width: auto;
    }

    .modal-body {
        max-height: 700px;
        overflow: auto;
    }


    .signature-container{
        height: 150px;
        max-height: 150px;
        position: relative;
    }

    .signature-container > div{
        height: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .signature-container > div > span{
        position: absolute;
        top: -3px;
        right: 17px;
        padding: 0 10px;
        background: white;
    }

    .signature-container > div > img{
        object-fit: contain;
    }

    signature-pad {
        background: white !important;
    }

    form > .row:not(:last-child){
        border-bottom: 1px solid transparent!important;
    } 
    `
  ]

})

export class RefuleComponent implements OnInit {

  Id: number = 0;

  refule: any;

  list_Transformation: any = [];

  lst_Equipment: any = [];

  obj_Equipment: any = {};

  totalReview: any = {};

  EditeMod: boolean = false;

  iFuelReport: any;

  bTransformation: boolean = false;

  isDelivery: boolean = false;

  isTF_Confirmation: boolean = false;

  whichImage: string = '';

  sabtModel: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
    strUnitID: new FormControl(),
    iKm: new FormControl(''),
    iCost: new FormControl(),
    fLiter: new FormControl(),
    fLat: new FormControl(0),
    fLon: new FormControl(0),
    strLocationCode: new FormControl(""),
    strImage: new FormControl(""),
    strDate: new FormControl(''),
    strComment: new FormControl(''),
  });

  transformationModel: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),

    strUnitID: new FormControl('', Validators.required),

    strDelivery_FullName: new FormControl('', Validators.required),

    strDelivery_Mobile: new FormControl('', Validators.required),

    strTransferee_FullName: new FormControl('', Validators.required),

    strTransferee_Mobile: new FormControl('', Validators.required),

    strGlassesCondition: new FormControl('', Validators.required),

    strFrontCondition: new FormControl('', Validators.required),

    strRightCondition: new FormControl('', Validators.required),

    strLeftCondition: new FormControl('', Validators.required),

    strBackCondition: new FormControl('', Validators.required),

    strRoofCondition: new FormControl('', Validators.required),

    strCabinCondition: new FormControl('', Validators.required),

    strSupplies: new FormControl(''),

    strDocuments: new FormControl(''),

    strViolation: new FormControl(''),

    bSpare: new FormControl(false),

    iKM: new FormControl('', Validators.required),

    iFuel: new FormControl('0'),

    strDelivery_Signature: new FormControl('', Validators.required),

    strTransferee_Signature: new FormControl('', Validators.required),

    iCarTransformation: new FormControl(''),

    tfIndex: new FormControl('')


  });

  tf_ConfirmationModel: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),

    iCarTransformation: new FormControl('', Validators.required),

    iDelivery_OTP: new FormControl('', Validators.required),

    iTransferee_OTP: new FormControl('', Validators.required),

    strImage_Front: new FormControl(''),

    strImage_Right: new FormControl(''),

    strImage_Left: new FormControl(''),

    strImage_Back: new FormControl(''),

    strImage_Cabin: new FormControl(''),

    tfIndex: new FormControl('')

  });

  @ViewChild('signature') public signaturePad!: SignaturePadComponent;

  public signaturePadOptions: NgSignaturePadOptions = {
    minWidth: 5,
    canvasWidth: 400,
    canvasHeight: 300,
    backgroundColor: 'white'
  }

  constructor(

    private el: ElementRef,

    private notifyService: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private _location: Location,

    private gurdService: GurdServiceService,

  ) {

  }

  ngOnInit(): void {

    this.route.url.pipe(pluck(0, 'path')).subscribe((segment: any) => {

      this.bTransformation = (segment == 'transformation' ? true : false);

      // ? *** تحویل و تحول خودرو  *** // 1
      if (this.bTransformation) {

        this.route.params.pipe(pluck('id')).subscribe(el => this.Id = el);

        this.getAllTransformation();

        this.getCar();

      }

      // ? *** لیست سوختگیری ها *** // 2
      if (!this.bTransformation) {

        $('#exampleModal').on('hidden.bs.modal', () => {

          this.close();

          this.sabtModel.reset({
            iKm: "",
            iCost: "",
            fLiter: "",
            fLat: 0,
            fLon: 0,
            strLocationCode: "",
            strUnitID: this.Id,
            iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
            strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!)
          });

        });

        this.route.params.subscribe((params) => {

          this.Id = params['id'];

        });

        this.getAllRefule();

      }

    });

  }

  async newTransformation() {

    if (this.transformationModel.invalid) return this.notifyService.showError('لطفا اطلاعات ضروری را وارد کنید');

    if (!this.EditeMod) {

      $.confirm({

        title: `آیا از ثبت اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'green',

        buttons: {

          ok: {

            text: "ثبت",

            btnClass: 'btn-success',

            keys: ['enter'],

            action: async () => {

              $('#exampleModal').modal('hide')

              this.otherService.Showspinner();

              const resp = await axios.post(`CarTransformation_Save`, this.transformationModel.value);

              this.otherService.nonespinner();

              let res = JSON.parse(resp.data);

              if (res.bError || res.iResult == 0) {

                $('#exampleModal').modal('show')

                return this.notifyService.showError(res.strError);
              }

              else {

                this.list_Transformation.push(res[0]);

                this.tFModel_PathValue();

                return this.notifyService.showSuccess('اطلاعات با موفقیت ثبت شد');

              }

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              $('#exampleModal').modal('hide')

              this.otherService.Showspinner();

              const resp = await axios.post(`CarTransformation_Edit`, this.transformationModel.value);

              this.otherService.nonespinner();

              let res = JSON.parse(resp.data);

              if (res.bError) {

                $('#exampleModal').modal('show')

                return this.notifyService.showError(res.strError);
              }

              else {

                this.list_Transformation[this.transformationModel.controls['tfIndex'].value] = res[0];

                this.tFModel_PathValue();

                this.EditeMod = false;

                return this.notifyService.showSuccess('اطلاعات با موفقیت ثبت شد');

              }

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  async submitConfirmation() {

    if (this.tf_ConfirmationModel.invalid) return this.notifyService.showError('لطفا اطلاعات ضروری را وارد کنید');

    $('#exampleModal_3').modal('hide')

    this.otherService.Showspinner();

    const resp = await axios.post(`CarTransformation_Save_Final`, this.tf_ConfirmationModel.value);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if ((res.bError || res?.strError != '') && res?.strError != null) {

      $('#exampleModal_3').modal('show')

      return this.notifyService.showError(res.strError);
    }

    else {

      this.tFC_PathValue();

      this.list_Transformation[this.tf_ConfirmationModel.controls['tfIndex'].value].tiStatus = 1;

      return this.notifyService.showSuccess('اطلاعات با موفقیت ثبت شد');
    }

  }

  async openModal_Operation(item: any, index: number) {

    if (item.tiStatus == 0) {

      this.isTF_Confirmation = true;

      this.tFC_PathValue();

      this.tf_ConfirmationModel.controls['tfIndex'].setValue(index);

      this.tf_ConfirmationModel.controls['iCarTransformation'].setValue(item.iCarTransformation)

      $('#exampleModal_3').modal('show');

    }

    if (item.tiStatus == 1) {

      let model = {

        ...this.tf_ConfirmationModel.value,

        iCarTransformation: item.iCarTransformation,

      }

      this.isTF_Confirmation = false;

      this.otherService.Showspinner();

      const resp = await axios.post(`CarTransformation_Images`, this.otherService.stringNumberToNumber(model));

      this.otherService.nonespinner();

      let res = JSON.parse(resp.data);

      Object.keys(res).forEach(key => {

        this.tf_ConfirmationModel.get(key)?.setValue(res[key])

      })

      $('#exampleModal_3').modal('show');

    }

  }

  drawComplete(signature: any) {

    var base64Signature = signature.toDataURL();

    if (this.isDelivery) this.transformationModel.controls['strDelivery_Signature'].setValue(base64Signature.replace('data:image/png;base64,', ''))

    else this.transformationModel.controls['strTransferee_Signature'].setValue(base64Signature.replace('data:image/png;base64,', ''))

  }

  tFModel_PathValue() {

    this.transformationModel.patchValue({

      strTransferee_FullName: '',

      strTransferee_Mobile: '',

      strGlassesCondition: 'سالم',

      strFrontCondition: 'سالم',

      strRightCondition: 'سالم',

      strLeftCondition: 'سالم',

      strBackCondition: 'سالم',

      strRoofCondition: 'سالم',

      strCabinCondition: 'سالم',

      strSupplies: '',

      strDocuments: '',

      bSpare: false,

      iKM: '',

      iFuel: 0,

      strViolation: '',

      strDelivery_Signature: '',

      strTransferee_Signature: '',

    })

    this.transformationModel.controls['bSpare'].setValue(false)


  }

  tFC_PathValue() {

    this.tf_ConfirmationModel.patchValue({

      iCarTransformation: '',

      iDelivery_OTP: '',

      iTransferee_OTP: '',

      strImage_Front: '',

      strImage_Right: '',

      strImage_Left: '',

      strImage_Back: '',

      strImage_Cabin: '',

    })

  }

  seprator(e: any) {
    if (isNaN(e.key)) {
      return false;
    }
    this.otherService.insertComma(e);
    return true;
  }

  goBack() {
    this._location.back();
  }

  getAllRefule = async () => {
    var model = {
      strUnitID: this.Id,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    };
    const resp = await axios.post(
      `FuelReport_List`,
      model
    );
    resp.data = JSON.parse(resp.data);

    if (resp.data) {
      this.refule = resp.data;
      this.totalReview.totalCost = 0;
      this.totalReview.totalL = 0;
      this.refule.forEach((element: any) => {
        this.totalReview.totalCost += element.iCost;
        this.totalReview.totalL += element.fLiter;
      });
    }
  };

  getAllTransformation = async () => {

    this.otherService.Showspinner()

    var model = {

      strUnitID: this.Id,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    }

    const resp = await axios.post(`CarTransformation_List`, model);

    this.otherService.nonespinner()

    let res = JSON.parse(resp.data);

    this.list_Transformation = res;

    this.transformationModel.controls['strUnitID'].setValue(this.Id)

    this.transformationModel.controls['bSpare'].setValue(false)

  }

  getCar = async () => {

    var model = {

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.Id,

    };

    const resp = await axios.post(`GetCar?strUnitID=${this.Id}`, model);

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '12' } });

      return;

    }

    if (resp.data == null) {

      this.notifyService.showError('بروز خطا در سامانه');

      return;

    }

    else {

      this.transformationModel.patchValue({

        strDelivery_FullName: resp.data.strFullName,

        strDelivery_Mobile: resp.data.strMobile,

      })

    }

  };

  sabt = async () => {
    var model = this.sabtModel.value;
    model.strUnitId = this.Id;

    if (model.strDate == null || model.strDate == '') {
      this.notifyService.showError('تاریخ را وارد کنید');
      return;
    }
    if (model.iCost == null || model.iCost == '' || model.iCost <= 0) {
      this.notifyService.showError('لطفا مقدار هزینه را وارد کنید');
      return;
    }
    if (model.fLiter == null || model.fLiter == '' || model.fLiter <= 0) {
      this.notifyService.showError('لطفا مقدار حجم سوخت گیری را وارد کنید');
      return;
    }

    model.iKm = model.iKm == '' ? 0 : model.iKm;
    // model.iCost = parseFloat(model.iCost.replace(/,/g, ''));
    // model.fLiter = parseFloat(model.fLiter.replace(/,/g, ''));

    if (confirm('آیا از ثبت اطلاعات اطمینان دارید؟')) {
      const resp = await axios.post(
        `FuelReport_Save`,
        this.otherService.stringNumberToNumber(model)
      );
      resp.data = JSON.parse(resp.data);
      if (resp.data.iResult == 0) {
        this.notifyService.showError(resp.data.strError);
        return;

      }
      if (resp.data.ISSessionExpired == true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      }
      if (resp.data.iResult == 1) {
        this.notifyService.showSuccess('با موفقیت ثبت شد');
        this.getAllRefule();
        this.sabtModel.reset({
          iKm: "",
          iCost: "",
          fLiter: "",
          fLat: 0,
          fLon: 0,
          strLocationCode: "",
          strUnitID: this.Id,
          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!)
        });
        $('#exampleModal').modal('hide');
      }
    }
  };

  getSingel = async (Id: any) => {

    this.sabtModel.controls['iCost'].setValue(this.refule[Id].iCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    this.sabtModel.controls['strLocationCode'].setValue(this.refule[Id].strLocationCode);
    this.sabtModel.controls['iKm'].setValue(this.refule[Id].iKm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    this.sabtModel.controls['fLiter'].setValue(
      this.refule[Id].fLiter.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
    this.sabtModel.controls['strImage'].setValue(this.refule[Id].strImage);

    $('#exampleModal').modal('show');
    this.iFuelReport = this.refule[Id].iFuelReport;
    this.EditeMod = true;
  };

  edit = async () => {
    var model = this.sabtModel.value;
    model.strUnitId = this.Id;
    model.iFuelReport = this.iFuelReport;
    
    if (model.strDate == null || model.strDate == '') {
      this.notifyService.showError('تاریخ را وارد کنید');
      return;
    }

    if (model.iCost == null || model.iCost == '' || model.iCost <= 0) {
      this.notifyService.showError('لطفا مقدار هزینه را وارد کنید');
      return;
    }

    if (model.fLiter == null || model.fLiter == '' || model.fLiter <= 0) {
      this.notifyService.showError('لطفا مقدار حجم سوخت گیری را وارد کنید');
      return;
    }

    model.iKm = model.iKm == '' ? 0 : model.iKm;
    // model.iCost = parseFloat(model.iCost.replace(/,/g, ''));
    // model.fLiter = parseFloat(model.fLiter.replace(/,/g, ''));

    if (confirm('آیا از ویرایش اطلاعات اطمینان دارید؟')) {
      const resp = await axios.post(
        `FuelReport_Edit`,
        this.otherService.stringNumberToNumber(model)
      );
      resp.data = JSON.parse(resp.data);
      if (resp.data.iResult == 0) {
        this.notifyService.showError(resp.data.strError);
        return;

      }
      if (resp.data.ISSessionExpired == true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      }
      if (resp.data.iResult == 1) {
        this.notifyService.showSuccess('با موفقیت ثبت شد');
        this.getAllRefule();
        this.sabtModel.reset({
          iKm: "",
          iCost: "",
          fLiter: "",
          fLat: 0,
          fLon: 0,
          strLocationCode: "",
          strUnitID: this.Id,
          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!)
        });
        $('#exampleModal').modal('hide');
      }
    }
  };

  deleteRefule = async () => {
    if (confirm('آیا از حذف اطلاعات اطمینان دارید؟')) {

      var model = {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
        iFuelReport: this.iFuelReport,
      };
      const resp = await axios.post(
        `FuelReport_Delete`,
        model
      );
      resp.data = JSON.parse(resp.data);
      if (resp.data.iResult == 0) {
        this.notifyService.showError(resp.data.strError);
        return;

      }
      if (resp.data.ISSessionExpired == true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      }
      if (resp.data.iResult == 1) {
        this.notifyService.showSuccess('با موفقیت حذف شد');

        this.refule = this.refule.filter((el: any) => {
          return el.iFuelReport != this.iFuelReport;
        });
        $('#exampleModal').modal('hide');
      }

    }
  };

  close() {

    this.EditeMod = false;
  }

  open() {

    this.tFModel_PathValue();

    this.close();

    // برای نمایش دکمه های فوتر مدال

    setTimeout(() => {

      const element = document.getElementsByClassName('d-none')[1] as HTMLElement;

      element?.classList.toggle('d-none');

      element?.classList.toggle('modal-footer');

      (document.getElementsByTagName('form')[0] as HTMLElement).style.pointerEvents = "auto";

    }, 10);
  }

  guid(Id: any) {
    this.otherService.guid(Id);
  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.notifyService.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        base64String = base64String.replace('data:image/jpeg;base64,', '');

        if (this.whichImage != '') this.tf_ConfirmationModel.controls[this.whichImage].setValue(base64String)

        else this.sabtModel.controls['strImage'].setValue(base64String)

      };

    }

  }

  showFactor(item: any) {

    $.confirm({

      title: 'فاکتور',

      content: `<img src="data:image/jpeg;base64,${item.strImage}" alt="Your Image">`,

      type: 'blue',

      buttons: {

        cancel: {

          text: "بستن",

        }

      }

    });

  }

  async openEditModal(item: any, index: number, status?: 'showMode') {

    var model = {

      iCarTransformation: item.iCarTransformation,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    }

    this.otherService.Showspinner();

    const resp = await axios.post(`CarTransformation_Signatures`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.transformationModel.controls['iCarTransformation'].setValue(item.iCarTransformation)

    const newItem = Object.assign(res, item, {})

    Object.keys(newItem).forEach(key => {

      this.transformationModel.get(key)?.setValue(newItem[key])

    })

    this.transformationModel.controls['tfIndex'].setValue(index);

    this.EditeMod = true;

    $('#exampleModal').modal('show');

    setTimeout(() => {

      // برای پنهان کردن دکمه های فوتر مدال

      if (status) {

        document.getElementsByClassName('modal-title')[0].innerHTML = 'مشاهده';

        document.getElementsByClassName('modal-footer')[0].className = 'd-none';

        (document.getElementsByTagName('form')[0] as HTMLElement).style.pointerEvents = "none";
      }

      // برای نمایش دکمه های فوتر مدال

      else {

        document.getElementsByClassName('modal-title')[0].innerHTML = 'ویرایش';

        const element = document.getElementsByClassName('d-none')[1] as HTMLElement;

        element?.classList.toggle('d-none');

        element?.classList.toggle('modal-footer');

        (document.getElementsByTagName('form')[0] as HTMLElement).style.pointerEvents = "auto";

      }

    }, 10);

  }

  async removeTransportation(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iCarTransformation: item.iCarTransformation,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this.otherService.Showspinner();

            const resp = await axios.post(`CarTransformation_Delete`, model);

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError) return this.notifyService.showError(res.strError);

            this.list_Transformation.splice(index, 1);

            return this.notifyService.showSuccess('اطلاعات با موفقیت ثبت شد');

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  async openList_Modal(item: any, i: number) {

    this.obj_Equipment = item;

    var model = {

      iCarTransformation: item.iCarTransformation,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    }

    this.otherService.Showspinner();

    const resp = await axios.post(`CarTrans_EquipmentDelivered_List`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.lst_Equipment = res;

    $("#Equipment_Modal").modal("show")

  }

  openAddEquipment(model?: any) {

    $("#Equipment_Modal").modal("hide");

    if (model?.strTitle) {

      setTimeout(() => {

        $('input[name=value1]').val(model?.strTitle);

        $('input[name=value2]').val(model?.strValue);

      }, 10);

    }

    $.confirm({

      title: model ? 'ویرایش' : 'افزودن اقلام جدید',

      content: '' +
        '<form action="" class="formName">' +
        '<div class="form-group">' +
        '<label> عنوان </label>' +
        '<input type="text" name="value1" class="form-control" required>' +
        '</div>' +
        '<div class="form-group">' +
        '<label> مقدار </label>' +
        '<input type="text" name="value2" class="form-control" required>' +
        '</div>' +
        '</form>',

      buttons: {

        ok: {

          text: model ? 'ویرایش' : "ذخیره",

          btnClass: model ? 'btn-primary' : 'btn-success',

          keys: ['enter'],

          action: async () => {

            var value1 = $('input[name=value1]').val();

            var value2 = $('input[name=value2]').val();

            if (value1.trim() == '' || value2.trim() == '') {

              this.openAddEquipment()

              return this.notifyService.showError('لطفا مقادیر ضروری را وارد کنید')

            }

            else {

              if (model) {

                let model_2 = {

                  iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

                  strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

                  ...model,

                  strTitle: $('input[name=value1]').val(),

                  strValue: $('input[name=value2]').val()

                }

                this.otherService.Showspinner();

                const resp = await axios.post(`CarTrans_EquipmentDelivered_Edit`, this.otherService.stringNumberToNumber(model_2));

                this.otherService.nonespinner();

                let res = JSON.parse(resp.data);

                if (res.bError || res.iResult == 0) {

                  $("#Equipment_Modal").modal("show");

                  return this.notifyService.showError(res.strError);

                }

                this.lst_Equipment[model.index] = res[0];

                $("#Equipment_Modal").modal("show");

                this.notifyService.showSuccess('با موفقیت ویرایش شد')

              }

              else {

                let model = {

                  iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

                  strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

                  iCarTransformation: this.obj_Equipment.iCarTransformation,

                  strTitle: $('input[name=value1]').val(),

                  strValue: $('input[name=value2]').val()

                }

                this.otherService.Showspinner();

                const resp = await axios.post(`CarTrans_EquipmentDelivered_Save`, this.otherService.stringNumberToNumber(model));

                this.otherService.nonespinner();

                let res = JSON.parse(resp.data);

                if (res.bError || res.iResult == 0) return this.notifyService.showError(res.strError);

                this.lst_Equipment.push(res[0]);

                $("#Equipment_Modal").modal("show");

                this.notifyService.showSuccess('با موفقیت اضافه شد')

              }

            }

          }

        },

        cancel: {

          text: "لغو",

          action: async () => {

            $("#Equipment_Modal").modal("show");

          }

        }

      }

    });

  }

  edit_Equipment(item: any, index: number) {

    this.openAddEquipment({ index: index, ...item })

  }

  async remove_Equipment(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iCarTrans_EquipmentDelivered: item.iCarTrans_EquipmentDelivered,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this.otherService.Showspinner();

            const resp = await axios.post(`CarTrans_EquipmentDelivered_Delete`, model);

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError || res.iResult == 0) return this.notifyService.showError(res.strError);

            this.lst_Equipment.splice(index, 1)

            this.notifyService.showSuccess('با موفقیت حذف شد')

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async confirm_LastList() {

    $.confirm({

      title: `آیا از انجام این عملیات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "بارگذاری",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            var model = {

              iCarTransformation: this.obj_Equipment.iCarTransformation,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this.otherService.Showspinner();

            const resp = await axios.post(`CarTrans_EquipmentDelivered_LastList`, model);

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError || res.iResult == 0) return this.notifyService.showError(res.strError);

            this.lst_Equipment = res;

            this.notifyService.showSuccess('عملیات با موفقیت انجام شد');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

}
